// extracted by mini-css-extract-plugin
export default {"tableView":"_1PIHGS2_ag3UjWkhsdB5XV","table":"_3xwXTPwQidJbpsh7oIpj9W","checkboxColumnn":"_1PiZi5UKyUFafeAZEA691C","tooltipMsg":"_1L7AQwpZ-zygtem3bPXzRy"};